import type { PropsWithChildren, ReactNode } from "react";

import { Blockquote } from "@radix-ui/themes";

import { logger } from "@/src/infrastructure/datadog/Datadog";

type TypoBlockquoteProps = PropsWithChildren<{
  readonly darkBackground?: boolean;
}>;

export function TypoBlockquote({
  children,
  darkBackground = false,
}: TypoBlockquoteProps): ReactNode {
  if (darkBackground) {
    logger.warn("Unsupported quote block in rich text on dark mode");
    return <div>{children}</div>;
  }
  return <Blockquote className="my-2">{children}</Blockquote>;
}
